export const govLog = (_message: string) => {
	// console.log(message);
};

export const govApiLog = (_message: string) => {
	// console.log('[GOV API] ' + message);
};
